import React from 'react';
import '../styles/FusionGallerySection.css';

const FusionGallerySection = () => {
  // 创建包含11张图片的数组
  const images = Array.from({ length: 11 }, (_, i) => `/images/page15/${i + 1}.png`);
  
  return (
    <section className="fusion-gallery-section">
      <div className="fusion-gallery-container">
        <div className="fusion-gallery-grid">
          {images.map((image, index) => (
            <div key={index} className="fusion-gallery-item">
              <div className="fusion-gallery-image-wrapper">
                <img 
                  src={image} 
                  alt={`BOBO design ${index + 1}`} 
                  className="fusion-gallery-image" 
                />
              </div>
            </div>
          ))}
          {/* 添加一个带Coming Soon文字的格子作为第12个项目 */}
          <div className="fusion-gallery-item">
            <div className="fusion-gallery-image-wrapper coming-soon-wrapper">
              <img 
                src="/images/page15/12.png" 
                alt="Coming Soon" 
                className="fusion-gallery-image" 
              />
              <div className="coming-soon-text">Coming Soon</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FusionGallerySection; 